


import React, { useState } from "react";
import { Link } from "react-router-dom";

const Insights = ({ insightsLinks, setActive, setOpen, linkClicked }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleDesktopClick = () => {
    setActive && setActive("");
    linkClicked && linkClicked();
  };

  const handleMobileClick = () => {
    setOpen && setOpen(false);
    linkClicked && linkClicked();
  };

  return (
    <>
      {/* Desktop layout */}
      <div className="absolute top-0 xl:block hidden z-10 shadow-xl">
        <div className="bg-white p-2 min-w-[150px] max-w-[250px] rounded-b-md ">
          <ul className="flex flex-col">
            {insightsLinks.insights_1?.links?.subLink1?.map((item, index) => (
              <li key={index} className="list-none">
                <Link
                  to={item.link}
                  className={`block w-full px-2 py-1 text-base font-medium rounded-md transition-all duration-200 ease-in-out ${
                    hoveredIndex === index
                      ? "bg-[#ffebee] text-[#d32f2f]"
                      : "text-[#4a4949] hover:bg-[#ffebee] hover:text-[#d32f2f]"
                  }`}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  onClick={handleDesktopClick}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Mobile layout */}
      <div className="xl:hidden block pl-4">
        {insightsLinks.insights_1?.links?.subLink1?.map((item, index) => (
          <div key={index} className="border-b border-[#f3f4f6] last:border-b-0">
            <Link
              to={item.link}
              className="block px-4 py-3 text-base text-[#4a4949] transition-all duration-200 ease-in-out hover:bg-[#ffebee] hover:text-[#d32f2f]"
              onClick={handleMobileClick}
            >
              {item.name}
            </Link>
          </div>
        ))}
      </div>
    </>
  );
};

export default Insights;